import PropTypes from "prop-types"
import { columnsPropTypes, rowPropTypes } from "components/ui/Table/tablePropsTypes"
import { Draggable } from "react-beautiful-dnd"
import BaseTableRow from "./BaseTableRow"

const DraggableTableRow = ({
  columns,
  row,
  index,
  draggableType,
  className,
  style,
  onRowClick,
  isSelectable,
  onSelectChange,
  selectableField,
  isDeletable,
  onDeleteClick
}) => {
  return (
    <Draggable
      key={row.id || row.key}
      draggableId={row.id.toString() || row.key.toString()}
      index={index}
    >
      {(provided, snapshot) => {
        const onKeyDown = event => {
          if (event.target.nodeName === "INPUT") {
            return
          }
          provided.dragHandleProps.onKeyDown(event)
        }
        const patched = {
          ...provided.dragHandleProps,
          onKeyDown
        }
        return (
          <BaseTableRow
            columns={columns}
            row={row}
            index={index}
            className={className}
            style={style}
            draggableType={draggableType}
            provided={provided}
            {...patched}
            snapshot={snapshot}
            onRowClick={onRowClick}
            isSelectable={isSelectable}
            onSelectChange={onSelectChange}
            selectableField={selectableField}
            isDeletable={isDeletable}
            onDeleteClick={onDeleteClick}
          />
        )
      }}
    </Draggable>
  )
}

DraggableTableRow.propTypes = {
  columns: columnsPropTypes,
  row: rowPropTypes,
  index: PropTypes.number,
  draggableType: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onRowClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  onSelectChange: PropTypes.func,
  selectableField: PropTypes.string,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func
}

export default DraggableTableRow
